import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  userAccessRightsSuccess,
  userLoginErrorMsg,
  userLoginSuccessMsg,
  userProfileFetchSuccess,
  fetchUserPermissionsStart,
  fetchUserPermissionsSuccess,
  fetchUserPermissionsError,
} from "./reducer";
import { loginApi, logoutApi, listUserPermissionApi } from "services/authServcies";
import { resetDashboardState } from "../../dashboard/reducer";
import { useNavigate } from "react-router-dom";
const formatError = (error: any): { data: string } => ({
  data:
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong. Please try again.",
});

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    dispatch(resetDashboardState());
    
    const response = await loginApi({
      username: user.username,
      password: user.password, });

    if (response.success) {
      sessionStorage.setItem("authUser", JSON.stringify(response.data));
      sessionStorage.setItem("isLoggedIn", "true");

      dispatch(userLoginSuccessMsg(response.message || "Login Successful"));


      const adminData = {
        username: response.data.username,
        phone_no: response.data.phone_no,
        email_id: response.data.email_id,
      }

      try {
        // const userProfile = await getLoggedinUser();
        const userProfile = true;

        // const accessrights = userProfile?.data?.useraccessrights
        
        if (userProfile) {
          dispatch(loginSuccess());
          dispatch(userProfileFetchSuccess(adminData));
          // Fetch permissions in background; do not block navigation
          dispatch(fetchUserPermissions());
        } else {
          dispatch(apiError({ data: "Failed to load user profile." }));
        }
      } catch (error) {
        dispatch(apiError(formatError(error)));
        console.error("Failed to fetch user profile after login", error);
      }

      history("/dashboard");

      setTimeout(() => {
        dispatch(reset_login_flag());
      }, 5000);
    } else {
      dispatch(apiError({ data:  "Login failed" }));
      dispatch(userLoginErrorMsg(response.message||" Please check username or password"));

    }
  } catch (loginError: any) {
    const errorMessage =   "Login error. Please try again.";
    dispatch(userLoginErrorMsg(loginError?.response?.data?.message||errorMessage ));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    const response = {
      success: true
    };

    if (response?.success) {
      sessionStorage.removeItem("authUser");  
      sessionStorage.removeItem("isLoggedIn");  
      dispatch(resetDashboardState());
      
      dispatch(logoutUserSuccess());
      
      localStorage.setItem("logout", Date.now().toString());
      
      return "Logout successful";
    } else {
      dispatch(apiError({ data: "Logout failed" }));
    }
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
  const navigate = useNavigate()
  try {
    let response; 
    const socialdata = await response;

    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      navigate("/dashboard");
    }
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

export const fetchUserPermissions = () => async (dispatch: any) => {
  try {
    dispatch(fetchUserPermissionsStart());
    const response = await listUserPermissionApi();
    
    if (response.success && response.data) {
      const permissionNames = response.data.map((p: any) => p.permissionname || p);
      
      try {
        const authUser = sessionStorage.getItem("authUser");
        if (authUser) {
          const userData = JSON.parse(authUser);
          userData.permissions = permissionNames;
          sessionStorage.setItem("authUser", JSON.stringify(userData));
        }
      } catch (storageError) {
        console.error("Error saving permissions to sessionStorage:", storageError);
      }
      
      dispatch(fetchUserPermissionsSuccess(response.data));
      return response.data;
    } else {
      const errorMsg = response.message || "Failed to fetch user permissions";
      dispatch(fetchUserPermissionsError(errorMsg));
      return null;
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to fetch user permissions";
    dispatch(fetchUserPermissionsError(errorMessage));
    return null;
  }
};
